export default "/images/dac12017e189bb03d13778a8d4904e7d.avif";